module.exports = __webpack_public_path__ + "static/media/verified-bills.c9c0eeba.svg";